import { Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import ConditionGroup from "./ConditionGroup";
import { useOperatorsQuery } from "../../hooks/useOperatorsQuery";
import Loader from "../../../loader/loader";
import classes from "./ConditionsTree.module.scss";

/**
 * Top-level wrapper for the AND/OR condition tree. forJoin selects the side:
 * true → joinGroups, false → conditionGroups.
 */
export default function ConditionsTree({
  ruleId,
  queryId,
  forJoin = false,
  conditions,
  canEdit = true,
  isSubquery = false,
}) {
  const { t } = useTranslation();
  const { isLoading } = useOperatorsQuery();

  if (isLoading) {
    return (
      <div className={classes.section}>
        <Loader height="200px" />
      </div>
    );
  }

  const topGroup = (conditions && conditions[0]) || { fields: [] };

  return (
    <Stack gap={4} className={classes.section}>
      <Text size="sm" fw={600}>
        {forJoin ? t("dataFields.joins") : t("dataFields.conditions")}
      </Text>
      <div
        className={`${classes.wrapper} ${isSubquery ? classes.subquery : ""}`}
      >
        <ConditionGroup
          ruleId={ruleId}
          queryId={queryId}
          forJoin={forJoin}
          conditionGroupData={topGroup}
          isTopLevel
          canEdit={canEdit}
        />
      </div>
    </Stack>
  );
}
